import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { throttle } from 'lodash';

import {
  About,
  Edit,
  BlogList,
} from './container';
import './App.css';

const { REACT_APP_GA_ID } = process.env;

(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
window.ga('create', REACT_APP_GA_ID, 'auto');
window.ga('send', 'pageview');

const track = throttle(location => {
  console.log("tracking page view: " + location.pathname);
  window.ga('send', 'pageview', location.pathname);
}, 100);

class App extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      track(this.props.location);
    }
  }

  render(props) {
    return (
      <Switch>
        <Route exact path="/" {...props} component={ BlogList }/>
        <Route path="/edit/:id?" {...props} component={ Edit }/>
        <Route path="/about" {...props} component={ About }/>
      </Switch>
    );
  }
}
App = withRouter(App);


export default App;



// WEBPACK FOOTER //
// ./src/App.js